module.exports = __webpack_public_path__ + "img/6.87dba8d8.png";